import { render, staticRenderFns } from "./addWalletPoints.vue?vue&type=template&id=48b0c74b"
import script from "./addWalletPoints.vue?vue&type=script&lang=js"
export * from "./addWalletPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports